<template>
    <van-row style="margin-left: 5px; font-weight: bold; margin-top: 5px; min-height: 10px">
        <van-col span="6">
            <JdSortButton id="sort1" width="100%"
                          style="text-align: center"
                          :value="synthetical_value"
                          :label="synthetical_label"
                          @onSelect="onSortSelect">
                <div slot="right-icon"></div>
                综合排序
            </JdSortButton>
        </van-col>
        <van-col span="6">
            <JdSortButton id="sort2" width="100%" btnType="order"
                          style="text-align: center"
                          :value="commission_value"
                          :label="commission_label"
                          @onSelect="onSortSelect">
                佣金
            </JdSortButton>
        </van-col>
        <van-col span="6" style="">
            <JdSortButton id="sort3" width="100%" btnType="order"
                          style="text-align: left"
                          :value="commissionShare_value"
                          :label="commissionShare_label"
                          @onSelect="onSortSelect">
                佣金比例
            </JdSortButton>
        </van-col>
        <van-col span="6">
            <JdSortButton id="sort4" width="100%" btnType="order"
                          style="text-align: left"
                          :value="inOrderCount30Days_value"
                          :label="inOrderCount30Days_label"
                          @onSelect="onSortSelect">
                月销量
            </JdSortButton>
        </van-col>
    </van-row>
</template>

<script>
    import JdSortButton from "./JdSortButton";
    export default {
        name: "JdSortTabs",
        components: {JdSortButton},
        data(){
            return{
                //综合排序是否被选中
                synthetical_value: true,
                //佣金排序是否被选中
                commission_value: false,
                //佣金比例排序是否被选中
                commissionShare_value: false,
                //月销量排序是否被选中
                inOrderCount30Days_value: false,

                //综合排序标签识别
                synthetical_label: "synthetical",
                //佣金排序标签识别
                commission_label: "commission",
                //佣金比例标签识别
                commissionShare_label: "commissionShare",
                //月销量排标签识别
                inOrderCount30Days_label: "inOrderCount30Days",
            }
        },
        methods:{
            /**
             * 排序选项被选中
             */
            onSortSelect(label, check, sort) {

                if (label === this.synthetical_label) {
                    this.synthetical_value = true;
                    this.commission_value = false;
                    this.commissionShare_value = false;
                    this.inOrderCount30Days_value = false;
                    if (check) {
                        // this.all_params.sortName = "";
                        // this.all_params.sort = sort;
                        this.$emit("onSelect", "", sort)
                    }else{
                        // this.all_params.sortName = "";
                        // this.all_params.sort = "";
                        this.$emit("onSelect", "", "")
                    }

                } else {
                    if (label === this.commission_label) {
                        this.synthetical_value = false;
                        this.commission_value = true;
                        this.commissionShare_value = false;
                        this.inOrderCount30Days_value = false;
                    } else if (label === this.commissionShare_label) {
                        this.synthetical_value = false;
                        this.commission_value = false;
                        this.commissionShare_value = true;
                        this.inOrderCount30Days_value = false;
                    } else if (label === this.inOrderCount30Days_label) {
                        this.synthetical_value = false;
                        this.commission_value = false;
                        this.commissionShare_value = false;
                        this.inOrderCount30Days_value = true;
                    }

                    // this.all_params.sortName = label;
                    // this.all_params.sort = sort;
                    this.$emit("onSelect", label, sort)
                }
            },

            /**
             * 初始化状态
             */
            initSortStatus(){
                this.synthetical_value = true;
                this.commission_value = false;
                this.commissionShare_value = false;
                this.inOrderCount30Days_value = false;
            },
        }
    }
</script>

<style scoped>

</style>